export default __webpack_public_path__ + "static/media/Snd1.e9b30017.mp3";